import {Radio} from '@mui/material';
import {styled} from '@mui/material/styles';

const baseRadioStyles = ({theme}) => ({
  'padding': 0,
  'borderRadius': '50%',
  'width': 16,
  'height': 16,
  'position': 'relative',
});

const ZmRadioIcon = styled('div')(({theme}) => ({
  ...baseRadioStyles({theme}),
  'backgroundColor': 'transparent',
  'border': `1px solid ${theme.palette.common.swatch['50']}`,
  '.Mui-focusVisible &': {
    outline: '2px auto rgba(19,124,189,.6)',
    outlineOffset: 2,
  },
  'input:hover ~ &': {
    'backgroundColor': 'transparent',
    'border': `1px solid ${theme.palette.common.swatch['60']}`,
  },
  'input:active ~ &': {
    'backgroundColor': 'transparent',
    'border': `1px solid ${theme.palette.common.swatch['70']}`,
  },
  'input:disabled ~ &': {
    border: `1px solid ${theme.palette.common.swatch['30']}`,
    backgroundColor: 'transparent',
  },
}));

const ZmCheckedRadioIcon = styled('div')(({theme}) => ({
  ...baseRadioStyles({theme}),
  'backgroundColor': theme.palette.primary.swatch['60'],
  'input:hover ~ &': {
    backgroundColor: theme.palette.primary.swatch['70'],
  },
  'input:active ~ &': {
    backgroundColor: theme.palette.primary['80'],
  },
  'input:disabled ~ &': {
    borderColor: theme.palette.common.swatch['30'],
    backgroundColor: theme.palette.primary.swatch['20'],
  },
  '.Mui-focusVisible &': {
    outline: `1px solid #4D90FE`,
    outlineOffset: '2px',
  },
  '.knob': {
    'position': 'absolute',
    'borderRadius': '4px',
    'width': '8px',
    'height': '8px',
    'left': '4px',
    'top': '4px',
    'backgroundColor': theme.palette.common.white,
    'boxShadow': '0px 1px 1px rgba(19, 22, 25, 0.4), 0px 1px 2px rgba(19, 22, 25, 0.2)',
  },
}));

export const ZmRadio = (props) => {
  return (
    <Radio
      disableRipple
      color="default"
      checkedIcon={<ZmCheckedRadioIcon><div className="knob"></div></ZmCheckedRadioIcon>}
      icon={<ZmRadioIcon />}
      {...props}
    />
  );
};
